// extracted by mini-css-extract-plugin
module.exports = {"root":"FooterLegal_root__g_e4Z"};